import { StickyPanel } from '../../../../shared/ui/sticky-panel/StickyPanel';
import { CampaignsSidebar } from './CampaignsSidebar';

export function StickyCampaignsSidebar({ onSelect }) {
  return (
    <StickyPanel
      stickyTopVar="--campaign-cadences-sticky-top-offset"
      stickyTopFallback={100}
      width="var(--campaigns-sidebar-width)"
    >
      <CampaignsSidebar onSelect={onSelect} />
    </StickyPanel>
  );
}
